<email-layout>
  <ng-container logo>
    <email-tellent-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data().header" [subheader]="data().subheader_html" />
  </ng-container>

  <ng-container body>
    <email-infobox [contents]="data().infobox_html" [wrapperTag]="'p'" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
